import { z } from 'zod';

/**
 * The 409s the logistics site-map rules raise, as `details` of the error
 * envelope. One definition the backend types what it throws with, so a
 * renamed reason or field is a compile error rather than a silent drift.
 */
const StaleConflictSchema = z.object({ reason: z.literal('logistics-stale') });

export const LogisticsConflictSchema = z.discriminatedUnion('reason', [
  /** A material lives in only one area of a plan. */
  z.object({
    reason: z.literal('material-in-other-area'),
    materialName: z.string(),
    areaId: z.string(),
    areaName: z.string(),
  }),
  /** An area still holding stock cannot be deleted. */
  z.object({ reason: z.literal('area-holds-stock'), count: z.number().int().positive() }),
  /** Something on the site's logistics changed since the page loaded. */
  StaleConflictSchema,
]);

export type LogisticsConflict = z.infer<typeof LogisticsConflictSchema>;

const StaleEnvelopeSchema = z.object({ error: z.object({ details: StaleConflictSchema }) });

/** Whether a 409 body is the revision gate's stale refusal. */
export function isLogisticsStaleRefusal(body: unknown): boolean {
  return StaleEnvelopeSchema.safeParse(body).success;
}
